import {AuthGuard} from './core/guards/auth.guard';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {FirmsComponent} from './firms/firms.component';
import {UpdatesComponent} from './updates/updates.component';
import {RecordsComponent} from './records/records.component';
import {SupportComponent} from './support/support.component';
import {FirmGroupsComponent} from './firm-groups/firm-groups.component';
import {FirmAutomatsComponent} from './firm-automats/firm-automats.component';
import {FirmPayvendComponent} from './firm-payvend/firm-payvend.component';
import {FirmVendcardComponent} from './firm-vendcard/firm-vendcard.component';
import {FirmSimcardComponent} from './firm-simcard/firm-simcard.component';
import {FirmBeaconsComponent} from './firm-beacons/firm-beacons.component';
import {FirmTicketComponent} from './firm-ticket/firm-ticket.component';
import {ProductCategoryComponent} from './product-category/product-category.component';
import {ProductFilterComponent} from './product-filter/product-filter.component';
import {HavingTypeComponent} from './having-type/having-type.component';
import {HavingComponent} from './having/having.component';
import {HavingFirmComponent} from './having-firm/having-firm.component';
import {FirmModemComponent} from './firm-modem/firm-modem.component';
import {FirmDeviceComponent} from './firm-device/firm-device.component';
import {AddAutomatComponent} from './add-automat/add-automat.component';
import {EditAutomatComponent} from './edit-automat/edit-automat.component';
import {AllAutomatsComponent} from './all-automats/all-automats.component';
import {FirmUsersComponent} from './firm-users/firm-users.component';
import {UsersComponent} from './users/users.component';
import {BrandComponent} from './brand/brand.component';
import {CategoriesComponent} from './categories/categories.component';
import {AutomatBrandsComponent} from './automat-brands/automat-brands.component';
import {AutomatBrandDetailComponent} from './automat-brand-detail/automat-brand-detail.component';
import {ProductsTypeComponent} from './products-type/products-type.component';
import {AddProductComponent} from './add-product/add-product.component';
import {ProductTagComponent} from './product-tag/product-tag.component';
import {FirmPaymentComponent} from './firm-payment/firm-payment.component';
import {DeviceLogComponent} from './device-log/device-log.component';

@NgModule({
    exports: [RouterModule]
})
export class AppRoutingModule {
}

const routes: Routes = [
    {path: 'login', component: LoginComponent},
    {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard]},
    {path: 'firms', component: FirmsComponent, canActivate: [AuthGuard]},
    {path: 'products-type', component: ProductsTypeComponent, canActivate: [AuthGuard]},
    {path: 'havings', component: HavingComponent, canActivate: [AuthGuard]},
    {path: 'updates', component: UpdatesComponent, canActivate: [AuthGuard]},
    {path: 'records', component: RecordsComponent, canActivate: [AuthGuard]},
    {path: 'support', component: SupportComponent, canActivate: [AuthGuard]},
    {path: 'firm-groups', component: FirmGroupsComponent, canActivate: [AuthGuard]},
    {path: 'firm-payment', component: FirmPaymentComponent, canActivate: [AuthGuard]},
    {path: 'firm-automats', component: FirmAutomatsComponent, canActivate: [AuthGuard]},
    {path: 'firm-payvend/:flag', component: FirmPayvendComponent, canActivate: [AuthGuard]},
    {path: 'firm-vendcard', component: FirmVendcardComponent, canActivate: [AuthGuard]},
    {path: 'firm-simcard/:flag', component: FirmSimcardComponent, canActivate: [AuthGuard]},
    {path: 'firm-beacons/:flag', component: FirmBeaconsComponent, canActivate: [AuthGuard]},
    {path: 'firm-ticket', component: FirmTicketComponent, canActivate: [AuthGuard]},
    {path: 'firm-modem/:flag', component: FirmModemComponent, canActivate: [AuthGuard]},
    {path: 'firm-device/:flag', component: FirmDeviceComponent, canActivate: [AuthGuard]},
    {path: 'firm-users', component: FirmUsersComponent, canActivate: [AuthGuard]},
    {path: 'havings-type', component: HavingTypeComponent, canActivate: [AuthGuard]},
    {path: 'havings-firm/:name', component: HavingFirmComponent, canActivate: [AuthGuard]},
    {path: 'product-category/:name', component: ProductCategoryComponent, canActivate: [AuthGuard]},
    {path: 'products', component: ProductFilterComponent, canActivate: [AuthGuard]},
    {path: 'product-tags', component: ProductTagComponent, canActivate: [AuthGuard]},
    {path: 'add-automat', component: AddAutomatComponent, canActivate: [AuthGuard]},
    {path: 'add-product', component: AddProductComponent, canActivate: [AuthGuard]},
    {path: 'edit-automat', component: EditAutomatComponent, canActivate: [AuthGuard]},
    {path: 'all-automats', component: AllAutomatsComponent, canActivate: [AuthGuard]},
    {path: 'brand', component: BrandComponent, canActivate: [AuthGuard]},
    {path: 'categories', component: CategoriesComponent, canActivate: [AuthGuard]},
    {path: 'users', component: UsersComponent, canActivate: [AuthGuard]},
    {path: 'automat-brands', component: AutomatBrandsComponent, canActivate: [AuthGuard]},
    {path: 'automat-brand-detail', component: AutomatBrandDetailComponent, canActivate: [AuthGuard]},
    {path: 'device-logs', component: DeviceLogComponent, canActivate: [AuthGuard]},

    {path: '', component: LoginComponent}
    /*{
      path: '',
      component: AuthorisedLayoutComponent,
      children: [
        { path: 'dashboard', component: DashboardComponent },
        { path: 'firms', component: FirmsComponent }
      ]
    },
    { path: 'login', component: LoginComponent }*/
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/app-routing.module.ts